export default "<div class=\"img-container\">\r\n    <img #image [src]=\"imageSource\">\r\n</div>"